import { render, staticRenderFns } from "./SSSAward.vue?vue&type=template&id=39912ede&"
import script from "./SSSAward.vue?vue&type=script&lang=js&"
export * from "./SSSAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports